<template>
  <div v-if="!permission.capabilities.View" class="animated fadeIn content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <b-card>
      <b-card-header class="custom-header">
        <div>
          <i class="icon-key mr-1"></i>
          {{ campaign_type.charAt(0).toUpperCase() + campaign_type.slice(1) }}
        </div>
        <router-link :to="`/campaign/${campaign_type}/new`" :event="permission.capabilities.Create ? 'click' : ''">
          <b-button variant="primary" :disabled="!permission.capabilities.Create">
            <i class="fa fa-plus"></i>&nbsp;New
          </b-button>
        </router-link>
      </b-card-header>
      <b-card-body v-if="isLoading">
        <spinner></spinner>
      </b-card-body>
      <b-card-body v-else>
        <v-client-table
          dark
          :columns="columns"
          :data="data"
          :options="options"
          :theme="theme"
          id="dataTable"
        >
          <a
            slot="name"
            slot-scope="props"
            title="View"
            :href="`/campaign/${campaign_type}/view/`"
          >{{props.row.name}}</a>
          <div slot="action" slot-scope="props">
            <div class="input-group input-group-sm action">
              <b-dropdown variant="link" size="sm" no-caret title="Tools">
                <template slot="button-content">
                  <i class="fa fa-cog" aria-hidden="true"></i>
                </template>
                <b-dropdown-item @click="openEditPage(props.row.id)" :disabled="!permission.capabilities.Edit">
                  <i class="fa fa-edit"></i>&nbsp;Edit
                </b-dropdown-item>
                <b-dropdown-item @click="openDeleteModal(props.row.id)" :disabled="!permission.capabilities.Delete">
                  <span style="color: #20a8d8;">
                    <i class="fa fa-trash"></i>&nbsp;Delete
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </v-client-table>
      </b-card-body>
    </b-card>
    <DeleteConfirmModal 
      v-bind:modalTitle="deleteModal.modalTitle"
      v-bind:modalMsg="deleteModal.modalMsg"
      v-bind:loginUserRoleName="deleteModal.loginUserRoleName"
      v-on:toggle="getDeleteAction($event)" 
      ref="deleteConfirmModal"
    />
    <InfoModal ref="infoModal"></InfoModal>
  </div>
</template>


<script>
import Vue from "vue";
import { apigClient } from "@/shared/api";
import { ClientTable, Event } from "vue-tables-2";
import miniToastr from "mini-toastr";
import sampleData from "./_dataMockup.js";
import VueNotifications from "vue-notifications";
import { router } from "../../router/index";
import moment from 'moment';
import 'moment-timezone';
import DeleteConfirmModal from "./../custom-components/DeleteConfirmModal";
import InfoModal from "@/shared/Modals.vue";
import Page403 from "@/views/pages/Page403.vue";

const Spinner = () => import("../shared/Spinner");

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

Vue.use(ClientTable);
Vue.use(VueNotifications, options);

export default {
  name: "List",
  components: {
    ClientTable,
    Spinner,
    Event,
    DeleteConfirmModal,
    InfoModal,
    Page403
  },
  data: function() {
    let campaign_type = this.$route.params.campaign_type;
    let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    let userTimezone = loginUserInfo.db.timezone || 'Asia/Bangkok';
    return {
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false,
        }
      },
      loginUserInfo: loginUserInfo,
      userTimezone : userTimezone,
      campaign_type: campaign_type,
      columns: ["action", "name", "category", "campaign_id", "createdAt"],
      data: [],
      isLoading: true,
      options: {
        headings: {
          action: "",
          name: "Name",
          username: "Category",
          campaign_id: "Id",
          createdAt: "Created At"
        },
        sortable: ["name", "category", "campaign_id"],
        filterable: ["name", "category"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        }
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      //For delete modal
      deleteModal:{
        modalTitle: 'Delete Campaign',
        modalMsg: '',
        loginUserRoleName: loginUserInfo.db.roleName,
        deleteAction: '',
      },
      id: null,
      campaign_id: null,
      name: null,
      title: null
    };
  },
  methods: {
    getPermission(){
      let that = this;
      const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if(this.$route.meta && userPermissionsBasedOnEntity){
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName+(this.campaign_type.charAt(0).toUpperCase() + this.campaign_type.slice(1));
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === that.permission.permissionBaseName);
        if(userPermissionBasedOnEntity){
          that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability=>{
            that.permission.capabilities[capability.label] = capability.value
          });
        }
      } else{
        router.push('/no-permission-given');
      }
      console.log('permission: ' , that.permission);
    },
    openEditPage: function(id) {
      this.id = id;
      this.campaign_id = this.data[id].campaign_id;
      localStorage.setItem("page_campaign_id", this.campaign_id);
      router.push(`/campaign/${this.campaign_type}/edit`);
    },
    openDeleteModal: function(id) {
      let that = this;
      that.deleteModal.deleteAction='';
      that.id = id;
      that.campaign_id = that.data[id].campaign_id;
      that.title = that.data[id].campaignName;
      that.deleteModal.modalMsg="Delete the Campaign '" + that.title  + "' ?";
      that.$refs.deleteConfirmModal.openModal();
    },
    getDeleteAction(data){
      let that = this;
      console.log(data);
      if(data && data.deleteAction){
        that.deleteModal.deleteAction=data.deleteAction;
        that.deleteCampaign();
      }
    },
    deleteCampaign: function() {
      let that = this;
      that.$refs.infoModal.openModal();
      that.changeInfoModalContent(
        "loading",
        "Processing...",
        (that.deleteModal.deleteAction=='MARK-AS-DELETED') ? "Deleting the Campaign ("+ that.title +")" :
        "Deleting the Campaign ("+ that.title +") permenently"
      );
      if(that.deleteModal.deleteAction=='MARK-AS-DELETED'){
        that.markCampaignAsDeleted(that);
      } else{
        let method = "DELETE";
        let pathTemplate = "/campaigns/" + that.campaign_id;
        let additionalParams = {};
        let pathParams = {};
        apigClient
          .invokeApi(pathParams, pathTemplate, method, additionalParams)
          .then(function(result) {
            if(result.data.status){
              console.log('delete campaign id: ' + that.campaign_id);
              that.changeInfoModalContent(
                "success",
                "Deleted success!",
                "The Campaign has been deleted"
              );
              setTimeout(that.$refs.infoModal.closeModal(), 1500);
              that.showSuccessMsg();
              that.loadAndUpdateTableListAfterItemDelete(that);
            } else{
              console.log('Error From API Endpoint: ' + result.data.message);
              that.changeInfoModalContent(
                "error",
                "Error Occured!",
                "Error From API Endpoint: " + result.data.message
              );
            }
          })
          .catch(function(error) {
            console.log("Error From API Endpoint: " + error.message);
            that.changeInfoModalContent(
              "error",
              "Error Occured!",
              "Error From API Endpoint: " + error.message
            );
          });
      }
    },
    markCampaignAsDeleted: (that) => {
      let method = 'PUT';
      let pathTemplate =  '/campaigns/'+that.campaign_id+'/mark-as-deleted';
      let additionalParams ={};
      let pathParams = {};
      let body ={
        updateBy:that.loginUserInfo.login_username
      }
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams,body)
      .then(function(result){
        if(result.data.status){
          console.log(result);
          that.changeInfoModalContent(
            "success",
            "Deleted success!",
            "The Campaign data has been deleted"
          );
          setTimeout(that.$refs.infoModal.closeModal(), 1500);
          that.showSuccessMsg();
          that.loadAndUpdateTableListAfterItemDelete(that);
        }else{
          console.log('Error From API Endpoint: ' + result.data.message);
          that.changeInfoModalContent(
            "error",
            "Error Occured!",
            "Error From API Endpoint: " + result.data.message
          );
        }
      }).catch( function(error){
        that.changeInfoModalContent(
          "error",
          "Error Occured!",
          "Error From API Endpoint: " + error.message
        );
      });
    },
    loadAndUpdateTableListAfterItemDelete: function(that) {
      Vue.delete(that.data, that.id);
    },
    changeInfoModalContent(status = null, title = null, message = null) {
      let that = this;
      that.$refs.infoModal.status = status ? status : that.$refs.infoModal.status;
      that.$refs.infoModal.title = title ? title : that.$refs.infoModal.title;
      that.$refs.infoModal.message = message ? message : that.$refs.infoModal.message;
    },
    loadCampaign: function() {
      this.isLoading = true;
      let method = "GET";
      let additionalParams = {
        queryParams: {
          params: JSON.stringify({
            table: "campaign",
            fields: ["id", "campaignName", "category", "company_id", "createdAt"],
            filter: [
              {
                fieldname: "campaignType",
                comparisonOperator: "=",
                value: this.campaign_type
              },
              {
                fieldname: "isDeleted",
                comparisonOperator: "=",
                value: false
              }
            ],
            includeCategoryInfo: true
          })
        }
      };
      let pathParams = {};
      let pathTemplate = "/campaigns";
      let that = this;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          console.log("result data=", result);
          that.data = result["data"]["data"].map((elem, index) => {
            elem.campaign_id = elem.id;
            elem.id = index;
            elem.company_id = elem.company_id;
            elem.name = elem.campaignName;
            elem.category = elem.categoryName;
            elem.createdAt = moment(moment.unix(elem.createdAt)).tz(that.userTimezone).format('YYYY-MM-DD HH:mm')
            return elem;
          });
          that.isLoading = false;
        })
        .catch(function(error) {
          console.log("ERROR ! Cannot get data:" + error);
          that.showErrorMsg();
        });
    },

    deleteElement: function() {
      this.data.splice(this.id, 1);
      //Update the id
      for (let i = this.id; i < this.data.length; i++) {
        this.data[i].id--;
      }
      console.log(this.data);
      //Do the back end request here to delete the element id (or dispatch some vuex action do it )...
    }
  },
  watch: {
    "$route.params.campaign_type": function(id) {
      this.campaign_type = this.$route.params.campaign_type;
      this.loadCampaign();
    }
  },
  mounted: function() {
    this.getPermission();
    if(!this.permission.capabilities.View){
      return;
    }
    this.loadCampaign();
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The campaign has been deleted"
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "Hey you",
      message: "Here is some info for you"
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "Wow, man",
      message: "That's the kind of warning"
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Something goes wrong"
    }
  }
};
</script>



<style lang="scss" scoped>
.VueTables__search-field {
  margin-left: 0.25rem;
  display: flex !important;
}

.VueTables {
  margin-top: 18px;
}

#dataTable {
  width: 95%;
  margin-top: 18px !important;
  margin: 0 auto;
}
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-secondary {
  background-color: none;
}
.modal-dialog {
  color: black;
}
.card-body {
  padding: 0 !important;
}
.VueTables__search-field {
  display: flex !important;
}
</style>


<style >
.VueTables__search-field {
  margin-left: 0.25rem;
  margin-top: 0.25em;
  display: flex !important;
}
</style>
